export function getSimpleCell(
  value: number | string,
  classes = '',
  addPercentage = false
): { value: number | string; cssClass: string; addPercentage: boolean } {
  return {
    value,
    cssClass: `tw-py-2 tw-text-gray-800 ${classes}`,
    addPercentage,
  };
}

export function getCellWithTooltip(
  value: number,
  tooltip: string,
  tooltipParams: any
): { value: number; cssClass: string; tooltip: string; tooltipParams: any } {
  return {
    value,
    cssClass: 'tw-py-2 tw-text-center tw-text-gray-800',
    tooltip,
    tooltipParams,
  };
}

export function getCellWithPercentage(
  value: number,
  coverage: number,
  tooltip: string,
  tooltipParams: any
): {
  value: number;
  cssClass: string;
  tooltip: string;
  tooltipParams: any;
  isPercentage: boolean;
  coverage: number;
  colorCondition: () => boolean;
  colorClass: { positive: string; negative: string };
} {
  return {
    value,
    cssClass: 'tw-py-2 tw-text-center',
    tooltip,
    tooltipParams,
    isPercentage: true,
    coverage,
    colorCondition: () => coverage >= 50,
    colorClass: {
      positive: 'tw-text-green-500',
      negative: 'tw-text-red-500',
    },
  };
}
